import axios from '@lib/axios';
import { useMutation } from '@tanstack/react-query';

interface Props {
  companyId?: string;
  onSuccess?: (filepath: string) => void;
}

export const useExportCompanyMembers = ({
  companyId,
  onSuccess
}: Props) => {
	const {
		mutate: onExportCompanyMembers,
    ...rest
	} = useMutation({
		mutationFn: async () => {
      const { data: { filename } } = await axios.get(`/recipients/download/${companyId}`)
      return filename;
    },
    onSuccess
	});

	return { onExportCompanyMembers, ...rest };
};